import cx from 'classnames'
import React from 'react'

import { PlayActions, SettingsActions } from '../../types'
import { SimpleSounds } from '../widgets/SimpleSounds'
import HeaderContainer from './HeaderContainer'
import InteractionView from './InteractionView'
import BottomContainer from './BottomContainer'

type Props = {
  isShowSocial: boolean
  actions: {
    playActions: PlayActions
    settingsActions: SettingsActions
  }
}
const PlayArea = ({ actions, isShowSocial }: Props) => {
  const { playActions, settingsActions } = actions
  const className = cx('playArea', { isShowSocial })
  return (
    <div className={className}>
      <HeaderContainer settingsActions={settingsActions} playActions={playActions} />
      <InteractionView />
      <BottomContainer playActions={playActions} />
      <SimpleSounds />
    </div>
  )
}

export default PlayArea
